import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DesplegableData } from '../../models/desplegable-data';

@Component({
  selector: 'app-drop-down-single-con-id',
  templateUrl: './drop-down-single-con-id.component.html',
  styleUrls: ['./drop-down-single-con-id.component.css']
})
export class DropDownSingleConIdComponent implements OnInit {

  @Input() data: DesplegableData[]|string[] = [];
  @Input() titulo:string;
  @Input() tituloHorizontal:string;
  @Input() valorPreSeleccionado: DesplegableData | string;
  @Input() refreshKey: any;
  @Output() elementoSeleccionado: EventEmitter<DesplegableData | string> = new EventEmitter<DesplegableData | string>();
  valorSeleccionado: DesplegableData | string;
  @Input() tituloArriba:boolean = true;
  @Input() width:string = 'auto';
  @Input() height:string = 'auto';
  @Input() errorClass:string = '';
  @Input() borderStyle:string;
  @Input() placeholder:string;
  @Input() maxHeight:string = '200px';

  dropdownOpen = false;

  constructor(private eRef: ElementRef) { }

  ngOnChanges(changes: SimpleChanges){
    if(changes['valorPreSeleccionado'] || changes['refreshKey']){
      this.valorSeleccionado = this.valorPreSeleccionado;
      this.elementoSeleccionado.emit(this.valorSeleccionado);
    }
  }

  ngOnInit() {
    this.valorSeleccionado = this.valorPreSeleccionado;
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectOption(opcion: DesplegableData | string) {
    this.valorSeleccionado = opcion;
    this.elementoSeleccionado.emit(opcion);
    this.dropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
    clickout(event: Event) {
      if (!this.eRef.nativeElement.contains(event.target)) {
        this.dropdownOpen = false;
      }
  }

  get conId(): boolean {
    if (this.data.length === 0) {
      return false;
    }
    // Check if all elements in the array are objects (DesplegableData)
    return (this.data as any[]).every(item => typeof item === 'object' && item !== null && 'id' in item && 'desc' in item);
  }

  get dataAsDesplegableData(): DesplegableData[] {
    return this.data as DesplegableData[];
  }

  get dataAsString(): string[] {
    return this.data as string[];
  }

  get valorSeleccionadoDesc(): string {
    if (this.conId && this.valorSeleccionado) {
      return (this.valorSeleccionado as DesplegableData).desc;
    }
    return this.valorSeleccionado as string;
  }

}
